/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { MainPageEvent, useMainPageDataSelector } from "../../MainUi";
import { AppReview } from "../../../api/apiCalls";
import { AppDetailsPageEvent } from "../AppDetailsPage";
import ReviewCard from "./ReviewCard";

interface ReviewsSummaryProps {
  reviews: AppReview[];
}

export default function ReviewsSummary({ reviews }: ReviewsSummaryProps) {
  const [seeMore, setSeeMore] = useState<boolean>(false);
  const [arrowClass, setArrowClass] = useState<string>("fas fa-arrow-down");

  const mainPageData = useMainPageDataSelector();
  const dispatch = useDispatch();

  const onWriteReview = () => {
    if (mainPageData.authState) {
      if (mainPageData.appUser.firstName) {
        dispatch({
          type: AppDetailsPageEvent.SHOW_ADD_REVIEW_MODAL,
        });
      } else {
        dispatch({
          type: MainPageEvent.SHOW_EDIT_PROFILE_MODAL,
        });
      }
    } else {
      dispatch({
        type: MainPageEvent.SHOW_SIGNIN_MODAL,
      });
    }
  };

  return (
    <div>
      <div className="row mt-5">
        <div className="col-sm-8">
          <p className="font-weight-bold mt-2 mb-0">Reviews</p>
        </div>
        <div className="col-sm-4 text-right">
          <span
            onClick={() => onWriteReview()}
            className="btn btn-light text-secondary"
            data-toggle="modal"
            data-target="#edit-profile-modal"
          >
            <i className="fas fa-pencil-alt"></i> Write a Review
          </span>
        </div>
      </div>
      <div className="row">
        {!reviews.length ? (
          <div className="col-sm-8">
            <p className="mt-2 mb-0 sub-text">No reviews to show</p>
          </div>
        ) : (
          <></>
        )}
        {seeMore
          ? reviews.map((review) => (
              <ReviewCard
                key={review.id}
                id={review.id}
                appId={review.appId}
                name={review.name}
                msisdn={review.msisdn}
                comment={review.comment}
                reviewDate={review.reviewDate}
              />
            ))
          : reviews
              .slice(0, 2)
              .map((review) => (
                <ReviewCard
                  key={review.id}
                  id={review.id}
                  appId={review.appId}
                  name={review.name}
                  msisdn={review.msisdn}
                  comment={review.comment}
                  reviewDate={review.reviewDate}
                />
              ))}
      </div>
      <div className="row mt-3 justify-content-end">
        {reviews.length > 2 ? (
          <div className="col-2 text-right">
            <button
              key={arrowClass}
              className="btn btn-light"
              onClick={() => {
                setSeeMore(!seeMore);
                setArrowClass(
                  arrowClass === "fas fa-arrow-down"
                    ? "fas fa-arrow-up"
                    : "fas fa-arrow-down"
                );
              }}
            >
              <i className={arrowClass}></i>
            </button>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
